/**
 * @desc: 资料进件
 * @create：2020/4/10
 * @author: lijun
 * @version: v1.0
 */

import * as Models from '@/api/T2/submitInfo'

export default {
  namespaced: true,
  actions: {
    async getEntryList(ctx, payload) {
      const res = await Models.getEntryList(payload)
      return res && res.status === 200 && res.data || {}
    },
    // 获取商户聚合支付信息
    async getUnionPayment(ctx, payload) {
      const res = await Models.getUnionPayment(payload)
      return res && res.status === 200 && res.data || {}
    },
    // 获取额度授信账户信息
    async getQueryCardList(ctx, payload) {
      const res = await Models.getQueryCardList(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 业务发行/添加商户
    async saveNewMerchant(ctx, payload) {
      const res = await Models.saveNewMerchant(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 修改商户信息
    async updateMerchant(ctx, payload) {
      const res = await Models.updateMerchant(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 生成档案号
    async createdFileNum(ctx, payload) {
      const res = await Models.createdFileNum(payload)
      return res && res.status === 200 && res.data || {}
    }
  }
}
